import { call, put, takeLatest } from 'redux-saga/effects';
import { 
    AVERAGE_CLAIMS_DATA_REQUEST,
    CONRACT_YIELD_DATA_REQUEST,
    EFFORT_INDEX_DATA_REQUEST,
    SERVICE_METRIC_DATA_REQUEST,
    SERVICE_METRIC_DATA_REQUEST_APPEAL,
    SERVICE_METRIC_DATA_REQUEST_DiGITAL,
    SERVICE_METRIC_DATA_REQUEST_SECRET 
} from '@src/middleware/actions/actionTypes';
import { setRequestError, setRequestLoading, setRequestSuccess } from '@src/middleware/actions/common/common.actions';
import { providerExperienceStateKeys } from '@src/CommonComponents/constant/constant';
import { getClaimsData, getEffortIndexData, getServiceMetricData } from '@src/middleware/services/provider-experience/provider-experience.service';
import { updateNavigationLink, fetchTopSearchedListRequest, providerSearchRequest, saveSearchDetailsRequest } from '@src/middleware/actions/ProviderSearchAction/ProviderSearchAction';
import { calculatePadding } from '@src/utility/commonUtilityServices';
import { getLoggedUser } from '@src/utility/createStorage';
const getServiceMethod :any= (key: string) => {
  switch (key) {
    case providerExperienceStateKeys.averageClaimsData:
      return getClaimsData;
    case providerExperienceStateKeys.effortIndexData:
      return getEffortIndexData;
      case providerExperienceStateKeys.serviceMetricsPost:
        return getServiceMetricData;
        case providerExperienceStateKeys.serviceMetricsAppeal:
        return getServiceMetricData;
        case providerExperienceStateKeys.serviceMetricsDigital:
        return getServiceMetricData;
        case providerExperienceStateKeys.serviceMetricsSecret:
        return getServiceMetricData;
    default:
      return getClaimsData;
  }
}
export function* fetchProviderExperienceData(action: any) {
  const { key, payload } = action;
  const loadingKey = `${key}Loading`;
  const errorKey = `${key}Error`;

  try {
    yield put(setRequestError(false, errorKey));
    yield put(setRequestLoading(true, loadingKey));

    const response = yield call(getServiceMethod(key), payload);
    

    yield put(setRequestLoading(false, loadingKey));

    if (response?.status === false) {
      yield put(setRequestError(true, errorKey));
    } else {
      yield put(setRequestSuccess(response?.Data, key));
    }
  } catch (error) {
    yield put(setRequestLoading(false, loadingKey));
    yield put(setRequestError(true, errorKey));
  }
}


export function* providerExperienceSaga() {
  yield takeLatest(AVERAGE_CLAIMS_DATA_REQUEST, fetchProviderExperienceData);
  yield takeLatest(EFFORT_INDEX_DATA_REQUEST, fetchProviderExperienceData);
  yield takeLatest(CONRACT_YIELD_DATA_REQUEST, fetchProviderExperienceData);
  yield takeLatest(SERVICE_METRIC_DATA_REQUEST, fetchProviderExperienceData);
  yield takeLatest(SERVICE_METRIC_DATA_REQUEST_APPEAL, fetchProviderExperienceData);
  yield takeLatest(SERVICE_METRIC_DATA_REQUEST_DiGITAL, fetchProviderExperienceData);
  yield takeLatest(SERVICE_METRIC_DATA_REQUEST_SECRET, fetchProviderExperienceData);
}


export default [providerExperienceSaga];
